module.exports = __webpack_public_path__ + "static/media/password.62428583.svg";